<template lang="pug">
  .wrapper
    .homeWrap
      .row
        .h20
          .homeL.
            Inviting the world-famous <a href="http://www.chio.com.tw/">Nineday Folk Art Group</a>,
            the Taiwanese Golden Melody Awards winner <a href="https://www.facebook.com/shout.cc/">Master Wu Xiong</a>, 
            and the four-time Grammy Award-Nominee design designer Xiao Qingyang to jointly create and design The CHAIRMAN's 12th album "The OFFERING".
            <br>Two years of blood sweat and tears went into creating this classic masterpiece.
        .h50 
          h1 The OFFERING
          //- img.spinText(src="/img/main-text.png")
          img.spinImg(src="/img/main01.png")
          img.mainGrey(src="/img/maingrey.png")
          img.mainColor(src="/img/maincolor.png")
          h4 The CHAIRMAN
        .m20
          .homeL.
            Inviting the world-famous <a href="http://www.chio.com.tw/">Nineday Folk Art Group</a>,
            the Taiwanese Golden Melody Awards winner Master Wu Xiong, 
            and the four-time Grammy Award-Nominee design designer <a href="https://www.facebook.com/shout.cc/">Xiao Qingyang</a> to jointly create and design The CHAIRMAN's 12th album "The OFFERING".
            <br>Two years of blood sweat and tears went into creating this classic masterpiece.
        .h20
          .homeR
            li.homeSong(v-for="song,index in musicPlaylist" @click="spinny(index);" )
              div(style="float:left") {{ index+1 }}. 
              .name
                .songEn {{song.titleEn}} <br> {{song.titleZh}}                
        .m20
          .homeR
            li.homeSong(v-for="song,index in musicPlaylist" @click="spinny(index);" )
              span.songEn {{song.titleEn}}
      audio(ref="audioElm" src="/song1.mp3" )
    //- BottomSmoke
    BottomDemons(:hide="spinned")
    RedButton

</template>

<style lang="scss">
  .name{
    overflow:hidden;
    float:left;
  }
  .songEn{
    margin-left:5px;
    transition: .3s;    
  }
  .songEn{
    opacity:1;
  }
  .name:hover > .songEn{
    margin-top:-25px;
  }  

  // @keyframes foreverSpin {
  //   from{transform:rotate(0deg)}
  //   to{transform:rotate(1099360deg)}
  // }
  @keyframes foreverSpin {
    from{transform:rotate(0deg)}
    to{transform:rotate(360deg)}
  }
  .homeL a{
    color:#757676;
    text-decoration: underline;
  }
  .homeWrap{
    width:80%;
    padding:0 15px;
    margin:0 auto;
    margin-top:50px;
  }
  .homeSong{
    list-style: none;
    margin: 10px 0;
    overflow:hidden;
    height:20px;
  }
  .h20, .m20{
    width:25%;
    float:left;
  }
  .m20{
    display:none;
    }
  .h50{
    width:50%;
    float:left;
    text-align:center;
    position:relative;
    height:800px;
    h4{
      margin-top:150px;
      position:absolute;
      bottom:80px;
      width:100%;
      text-align: center;
    }
  }
  
  .spinImg{
    position:absolute;
    opacity:.3;
    width:70%;
    top:100px;
    left:15%;
    transition:top 2s;
  }
  .spinImg.active{
    animation:foreverSpin 2s;
    // animation:foreverSpin 2000s;
  }
  .spinImg.moveDown{
    top:120px;
  }
  .spinImg.unset{
    animation-play-state: unset;
  }
  .mainGrey, .mainColor{
    position:absolute;
    width:8%;
    left:calc(50% - 4%);
    top:170px;
    transition:opacity 2s, top 2s;

  }
  .mainGrey{
    opacity:.8;
  }
  .mainGrey.active{
    opacity: 0;
    top:190px;
  }
  .mainColor{
    opacity:0;
  }
  .mainColor.active{
    opacity:.8;
    top:190px;
  }
  .homeL,.homeR{
    margin-top:200px;
    transition: margin-top 3s;
  }
  .homeL{
    text-align:center;
  }
  .homeL.active, .homeR.active{
    margin-top:250px;
  }
  .homeSong{
    cursor:pointer;
    // display:inline-block;
  }
  .songCh{
    display:none;
  }
  @media(max-width:1440px){
    .h50{
      height:700px;
    }
  }
  @media(max-width:760px){
  .smokeWrapper{
      height:100px;
    }
    .h50{
      width:100%;
    }
    .h20{
      display:none;
    }
    .homeL, .homeR{
      margin-top:15px;
    }
    .m20{
      display:block;
      width:100%;
      margin-bottom:100px;
    }
    .spinImg{
      width:calc(80%);
      left:10%;
    }
    .homeL.active, .homeR.active{
      margin-top:0px;
    }
    .spinImg.moveDown{
      top:100px;
    }
  }
  @media(max-width:414px){
    .h50{
      width:100%;
    }
    .h20{
      display:none;
    }
    .homeL, .homeR{
      margin-top:15px;
    }
    .m20{
      display:block;
      width:100%;
      margin-bottom:100px;
    }
    .spinImg{
      width:calc(80%);
      left:10%;
    }
    .homeL.active, .homeR.active{
      margin-top:0px;
    }
    .spinImg.moveDown{
      top:100px;
    }

  }
 
</style>

<script>
// @ is an alias to /src
import BottomSmoke from '@/components/BottomSmoke.vue'
import BottomDemons from '@/components/BottomDemons.vue'
import RedButton from '@/components/RedButton.vue'

export default {
  name: 'home',
  components: {
    BottomSmoke,
    BottomDemons,
    RedButton,
  },
  mounted:function(){
    var a = this.$refs.audioElm;
    a.src = `/song1.mp3`;
    a.addEventListener("canplaythrough", a.play());
    // var gogo = function(){setTimeout(a.play(),4000);}

    // a.play();
    // var a = this.$refs.audioElm;
        // a.src = `/song${song}.mp3`;
        // a.play();
    // var a = new Audio(`/song1.mp3`);
    // a.play();
  },
  data:function(){
    return {
      initial:true,
      spinned:false,
      playing:false,
      musicPlaylist: [
        {
          titleEn: "Hero Valley",				
          titleZh: "壹•••••英雄谷",
          url: "",
        },
        {
          titleEn: "The Goddess of Jiu-Tian",				
          titleZh: "貳•••••九天玄女",
          url: "/song.mp3",
        },
        {
          titleEn: "Life of the War Drum",				
          titleZh: "參•••••戰鼓人生",
          url: "https://soundbible.com/mp3/hyena-laugh_daniel-simion.mp3",
        },
        {
          titleEn: "Numbness",				
          titleZh: "肆•••••瘋人",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        },
        {
          titleEn: "Follow the Beat",				
          titleZh: "伍•••••對我打",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        },
        {
          titleEn: "Farm Together",				
          titleZh: "陸•••••做花來種田",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        },
        {
          titleEn: "The God of Fortune",				
          titleZh: "柒•••••有財神",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        },
        {
          titleEn: "Sacrifice to Welcome the Gods",				
          titleZh: "捌•••••迎神",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        },
        {
          titleEn: "The OFFERING",				
          titleZh: "玖•••••祭",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        },
        
      ],
    audio: "",
    audioFile:"",
      
    }
  },
  computed:{

  },
  watch:{
    
  },
  methods:{
    playMusic:function(song){
    	if (
				this.currentlyStopped == true &&
				this.currentSong + 1 == this.musicPlaylist.length
			) {
				this.currentSong = 0;
				this.changeSong();
			}
			if (!this.currentlyPlaying) {
				this.getCurrentTimeEverySecond(true);
				this.currentlyPlaying = true;
				this.audio.play();
			} else {
				this.stopAudio();
			}
			this.currentlyStopped = false;
    },
    stopMusic:function(song){

    },
    spinny: function(song){
      $('.spinImg').removeClass('active');
      var reset = function(){
        $('.spinImg').addClass('active');
      }      
      setTimeout(reset, 200)
      
      var a = this.$refs.audioElm;
        a.src = `/song${song}.mp3`;
        a.play();
        
      if (this.playing == false){              
        this.spinned = true;
        this.playing = true;
        $('.spinImg').addClass('moveDown');
        $('.mainColor').addClass('active');
        $('.mainGrey').addClass('active');
        $('.homeL').addClass('active');
        $('.homeR').addClass('active');

      }
    }
  }
}
</script>
